import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import {
  getProductsService,
  getProductDetailService,
  getRopService,
  getQuoteService,
  getPolicyService,
  getCountryDetailService,
  getTravelProductTypeService,
  getAoMasterDataService,
  getTakafulMasterDataService,
  getLicenseVehicleService,
  getPlateTypeDetailsService,
  getGigVehicaleValuationService,
  updateTakafulPremiumService,
  createTransactionDataUser,
  updateTransactionDataUser,
  sendPdfMail,
  sendVehilcInfoGigService
} from "../../api/productApi";
import { prepareGigInsuranceCardData, buildMotorInfoListGig } from "../../utils/gigHelpers";
import { prepareAoInsuranceCardData } from "../../utils/aoHelpers";
import { prepareTakafulInsuranceCardData } from "../../utils/takafulHelpers";
import { prepareOquicInsuranceCardData } from "../../utils/oqicHelpers";
import { prepareEbridgeInsuranceCardData } from "../../utils/ebridgeHelpers";
import { getEbridgeQuotesService } from "../../api/ebridgeApi";

export const getProducts = createAsyncThunk(
  "product/getProducts",
  async (data) => {
    const response = await getProductsService(data);
    return response.data;
  }
);
export const getProductDetail = createAsyncThunk(
  "product/getProductDetail",
  async (data) => {
    const response = await getProductDetailService(data);
    return response.data;
  }
);

export const getCountryDetail = createAsyncThunk(
  "product/getCountryDetail",
  async (id) => {
    const response = await getCountryDetailService(id);
    return response.data;
  }
);

export const getTravelProductType = createAsyncThunk(
  "product/getTravelProductType",
  async (data) => {
    const response = await getTravelProductTypeService(data);
    return response.data;
  }
);

export const getRop = createAsyncThunk("product/getRop", async (data) => {
  const response = await getRopService(data);
  return response.data;
});


export const sendVehicleInfoGig = createAsyncThunk("gig/vehilcInfo", async (data) => {
  const payload = buildMotorInfoListGig(data);
  const response = await sendVehilcInfoGigService(payload);
  return response.data;
});


export const getQuote = createAsyncThunk("product/getQuote", async (data) => {
  const response = await getQuoteService(data);
  return response.data;
});

export const getPolicy = createAsyncThunk("product/getPolicy", async (data) => {
  const response = await getPolicyService(data);
  return response.data;
});

export const getAoMasterData = createAsyncThunk(
  "product/getAoMasterData",
  async (data) => {
    const response = await getAoMasterDataService(data);
    return response.data;
  }
);

export const getTakafulMasterData = createAsyncThunk(
  "product/getTakafulMasterData",
  async (id) => {
    const response = await getTakafulMasterDataService(id);
    return response.data;
  }
);

export const getLicenseVehicle = createAsyncThunk(
  "product/getLicenseVehicle",
  async (data) => {
    // // console.log(data,'data1')
    const response = await getLicenseVehicleService(data);
    return response.data;
  }
);

export const getPlateTypeDetails = createAsyncThunk(
  "product/getPlateTypeDetails",
  async (id) => {
    const response = await getPlateTypeDetailsService(id);
    return response.data;
  }
);

export const getGigVehicaleValuation = createAsyncThunk(
  "product/getGigVehicaleValuation",
  async (data) => {
    const response = await getGigVehicaleValuationService(data);
    return response.data;
  }
);

export const updateTakafulPremium = createAsyncThunk(
  "product/updateTakafulPremium",
  async (data) => {
    const response = await updateTakafulPremiumService(data);
    return response.data;
  }
);


export const addTransactionData = createAsyncThunk(
  "user/transactionData",
  async (data) => {
    localStorage.setItem("transactionId", null)
    const response = await createTransactionDataUser(data);
    localStorage.setItem("transactionId", response?.data?.transaction_id);
    return response.data;
  }
);


export const updateTransactionData = createAsyncThunk(
  "user/updatetransactionData",
  async (data) => {
    const response = await updateTransactionDataUser(data);
    return response.data;
  }
);


export const sendPdfEmail = createAsyncThunk(
  "user/sendPdfmail",
  async (data) => {
    const response = await sendPdfMail(data);
    return response.data;
  }
);

export const getEbridgeQuotes = createAsyncThunk(
  "product/getEbridgeQuotes",
  async ({ requestData, productDetails }, { signal }) => {
    const response = await getEbridgeQuotesService(requestData, signal);
    const quotes = Array.isArray(response?.quotes) ? response.quotes : Array.isArray(response) ? response : [];
    return { quotes, productDetails };
  }
);







const productSlice = createSlice({
  name: "product",
  initialState: {
    productLoader: false,
    products: [],
    homeProducts: [],
    productDetailLoader: false,
    productDetail: [],
    status: null,
    productParameter: null,
    msg: "",
    ropData: null,
    ropLicense: null,
    ropVehicle: null,
    companyList: [],
    gigInsuranceData: null,
    companyLoader: false,
    quoteLoader: false,
    quoteData: {},
    policyLoader: false,
    policyData: null,
    countryDetails: null,
    travelProductType: null,
    aoInsuranceData: null,
    aoMasterData: null,
    aoMasterDataLoader: false,
    takafulInsuranceData: null,
    takafulInsuranceDataLoader: false,
    takafulMasterDataLoader: false,
    takafulMasterData: null,
    takafulTitleMasterData: null,
    takafulNationalityCompanyMasterData: null,
    takafulGovernateCompanyMasterData: null,
    takafulWilayatCompanyMasterData: null,
    fulfilledKeys: [],
    vehicleData: null,
    plateTypeDetails: null,
    gigVehicaleValuationData: null,
    oquicInsuranceData: null,
    fetchingVehicleDataLoader: false,
    updateTakafulPremiumLoader: false,
    ebridgeInsuranceData: null,
    ebridgeLoader: false,
  },
  reducers: {
    updateTotalPrice: (state, action) => {
      let { customAction, value, id } = action.payload;
      let { companyList } = JSON.parse(JSON.stringify(state));
      let companyIndex = companyList.findIndex((com) => com.id === id);
      let company = companyList.find((com) => com.id === id);

      if (customAction === "increment") {
        company["fixed_rate_value"] =
          parseInt(company["fixed_rate_value"]) + parseInt(value);
      } else if (customAction === "flat") {
        company["fixed_rate_value"] = parseFloat(value);
      } else {
        company["fixed_rate_value"] =
          parseInt(company["fixed_rate_value"]) - parseInt(value);
      }

      companyList[companyIndex] = company;
      return { ...state, companyList };
    },
    resetData: (state, action) => {
      localStorage.removeItem("product_detail");
      localStorage.removeItem("product_details");
      localStorage.removeItem("quoteData");
      localStorage.removeItem("product_inquiry");
      localStorage.removeItem("transactionId");
      return { ...state, companyList: [], quoteData: {}, policyData: null };
    },
    resetVehicleData: (state) => {
      state.vehicleData = null;
      state.ropLicense = null;
      state.ropVehicle = null;
      state.plateTypeDetails = null;
      state.gigVehicaleValuationData = null;
    },
    resetEbridgeData: (state) => {
      state.ebridgeInsuranceData = null;
      state.ebridgeLoader = false;
    },
    updateEbridgeInsuranceData: (state, action) => {
      const { object_id, cover_id, value } = action.payload;
      let ebridgeInsuranceData = JSON.parse(JSON.stringify(state.ebridgeInsuranceData));
      const companyIndex = ebridgeInsuranceData.findIndex(c => c.object_id === object_id);
      const company = ebridgeInsuranceData[companyIndex];
      const coverIndex = company.optional_covers.findIndex(c => c.coverCode === cover_id);
      const cover = company.optional_covers[coverIndex];

      company.premium_value = cover.isSelected
        ? (parseFloat(company.premium_value) - parseFloat(value)).toFixed(3)
        : (parseFloat(company.premium_value) + parseFloat(value)).toFixed(3);

      company.optional_covers[coverIndex].isSelected = !cover.isSelected;
      ebridgeInsuranceData[companyIndex] = company;
      return { ...state, ebridgeInsuranceData };
    },
    updateGigInsuranceData: (state, action) => {
      let { customAction, value, object_id, cover_id } = action.payload;
      let { gigInsuranceData } = JSON.parse(JSON.stringify(state));
      let companyIndex = gigInsuranceData.findIndex(
        (com) => com.object_id === object_id
      );
      let company = gigInsuranceData.find((com) => com.object_id === object_id);

      if (customAction === "increment") {
        company["premium_value"] = (
          parseFloat(company["premium_value"]) + parseFloat(value)
        ).toFixed(3);
      } else if (customAction === "flat") {
        company["premium_value"] = parseFloat(value).toFixed(3);
      } else {
        company["premium_value"] = (
          parseFloat(company["premium_value"]) - parseFloat(value)
        ).toFixed(3);
      }
      let coverIndex = company["optional_covers"].findIndex(
        (cover) => cover.id === cover_id
      );

      company["optional_covers"][coverIndex]["isSelected"] =
        !company["optional_covers"][coverIndex]["isSelected"];

      gigInsuranceData[companyIndex] = company;
      return { ...state, gigInsuranceData };
    },
    updateAoInsuranceData: (state, action) => {
      const { customAction, value, object_id, cover_id } = action.payload;

      // Deep clone (as you already do)
      let { aoInsuranceData } = JSON.parse(JSON.stringify(state));

      const companyIndex = aoInsuranceData.findIndex(
        (com) => com.object_id === object_id
      );
      const company = aoInsuranceData[companyIndex];

      // 🔹 Find previously selected cover
      const prevSelectedCover = company.covers.find(
        (cover) => cover.isSelected
      );

      // 🔹 Remove previous premium if exists
      if (prevSelectedCover) {
        company.premium_value = (
          parseFloat(company.premium_value) -
          parseFloat(prevSelectedCover.premium || 0)
        ).toFixed(3);
      }

      // 🔹 Unselect ALL covers
      company.covers = company.covers.map((cover) => ({
        ...cover,
        isSelected: false,
      }));

      // 🔹 Select the clicked cover
      const coverIndex = company.covers.findIndex(
        (cover) => cover.code === cover_id
      );

      company.covers[coverIndex].isSelected = true;

      // 🔹 Add new premium
      company.premium_value = (
        parseFloat(company.premium_value) + parseFloat(value)
      ).toFixed(3);

      aoInsuranceData[companyIndex] = company;

      return { ...state, aoInsuranceData };
    },

    // updateAoInsuranceData: (state, action) => {
    //   let { customAction, value, object_id, cover_id } = action.payload;

    //   let { aoInsuranceData } = JSON.parse(JSON.stringify(state));
    //   let companyIndex = aoInsuranceData.findIndex(
    //     (com) => com.object_id === object_id
    //   );
    //   let company = aoInsuranceData.find((com) => com.object_id === object_id);

    //   if (customAction === "increment") {
    //     company["premium_value"] = (
    //       parseFloat(company["premium_value"]) + parseFloat(value)
    //     ).toFixed(3);
    //   } else if (customAction === "flat") {
    //     company["premium_value"] = parseFloat(value).toFixed(3);
    //   } else {
    //     company["premium_value"] = (
    //       parseFloat(company["premium_value"]) - parseFloat(value)
    //     ).toFixed(3);
    //   }
    //   let coverIndex = company["covers"].findIndex(
    //     (cover) => cover.code === cover_id
    //   );

    //   company["covers"][coverIndex]["isSelected"] =
    //     !company["covers"][coverIndex]["isSelected"];

    //   aoInsuranceData[companyIndex] = company;
    //   return { ...state, aoInsuranceData };
    // },
    updateOquicInsuranceData: (state, action) => {
      let { customAction, value, cover_id, object_id } = action.payload;

      // Deep clone the oquicInsuranceData
      let oquicInsuranceData = JSON.parse(
        JSON.stringify(state.oquicInsuranceData)
      );

      let companyIndex = oquicInsuranceData.findIndex(
        (com) => com.object_id === object_id
      );

      let company = oquicInsuranceData.find(
        (com) => com.object_id === object_id
      );

      // Find index of the cover by cover_id
      let coverIndex = company?.optional_covers?.findIndex(
        (cover) => cover.code === cover_id
      );

      if (customAction === "increment") {
        company["premium_value"] = (
          parseFloat(company["premium_value"]) + parseFloat(value)
        ).toFixed(3);
      } else if (customAction === "flat") {
        company["premium_value"] = parseFloat(value).toFixed(3);
      } else {
        company["premium_value"] = (
          parseFloat(company["premium_value"]) - parseFloat(value)
        ).toFixed(3);
      }

      // Toggle the isSelected property of the cover
      company["optional_covers"][coverIndex]["isSelected"] =
        !company["optional_covers"][coverIndex]["isSelected"];

      oquicInsuranceData[companyIndex] = company;

      return { ...state, oquicInsuranceData };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state, action) => {
        state.productLoader = true;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        let products = action.payload?.data;
        state.products = products;
        state.homeProducts =
          products && products.length
            ? products.filter((data) => data.is_home === "1")
            : [];
        state.status = true;
        state.msg = action.payload.msg;
        state.productLoader = false;
      })
      .addCase(getProducts.rejected, (state, action) => {
        console.error(action.payload);
        state.productLoader = false;
      })
      .addCase(getProductDetail.pending, (state, action) => {
        state.productDetailLoader = true;
      })
      .addCase(getProductDetail.fulfilled, (state, action) => {
        state.productDetail = action.payload?.data?.data;
        state.status = true;
        state.msg = action.payload.msg;
        state.productDetailLoader = false;
      })
      .addCase(getProductDetail.rejected, (state, action) => {
        console.error(action.payload);
        state.productDetailLoader = false;
      })
      .addCase(getRop.pending, (state) => {
        state.fetchingVehicleDataLoader = false;
        state.companyLoader = true;
      })
      .addCase(getRop.fulfilled, (state, action) => {
        state.companyList =
          action.payload?.companyList && action.payload?.companyList.length
            ? action.payload?.companyList.filter(
              (item) =>
                item?.insurance_company_id !== 4 &&
                item?.insurance_company_id !== 5 &&
                item?.insurance_company_id !== 1 &&
                item?.insurance_company_id !== 2
            )
            : [];
        //check travel_product_type param null or not
        let travel_product_type = state.travelProductType
          ? current(state.travelProductType)
          : null;
        //prepareGigInsuranceCardData
        let gigCompanyData =
          action.payload?.companyList && action.payload?.companyList.length
            ? action.payload?.companyList.filter(
              (item) => item?.insurance_company_id === 4
            )
            : [];
        state.gigInsuranceData = prepareGigInsuranceCardData(
          gigCompanyData,
          travel_product_type
        );
        //prepareAoInsuranceCardData
        let aoInsuranceCompanyData =
          action.payload?.companyList && action.payload?.companyList.length
            ? action.payload?.companyList.filter(
              (item) => item?.insurance_company_id === 5
            )
            : [];
        state.aoInsuranceData = prepareAoInsuranceCardData(
          aoInsuranceCompanyData,
          travel_product_type
        );
        //prepareTakafulInsuranceCardData
        let takafulInsuranceCompanyData =
          action.payload?.companyList && action.payload?.companyList.length
            ? action.payload?.companyList.filter(
              (item) => item?.insurance_company_id === 1
            )
            : [];
        state.takafulInsuranceData = prepareTakafulInsuranceCardData(
          takafulInsuranceCompanyData,
          travel_product_type
        );
        //prepareOquicInsuranceCardData
        let oquicInsuranceCompanyData =
          action.payload?.companyList && action.payload?.companyList.length
            ? action.payload?.companyList.filter(
              (item) => item?.insurance_company_id === 2
            )
            : [];
        state.oquicInsuranceData = prepareOquicInsuranceCardData(
          oquicInsuranceCompanyData,
          travel_product_type
        );
        state.companyLoader = false;
      })
      .addCase(getRop.rejected, (state, action) => {
        state.companyLoader = false;
        state.companyList = action.payload;
      })
      .addCase(getQuote.pending, (state) => {
        state.quoteLoader = true;
      })
      .addCase(getQuote.fulfilled, (state, action) => {
        state.quoteLoader = false;
        state.quoteData = action.payload;
      })
      .addCase(getQuote.rejected, (state, action) => {
        state.quoteLoader = false;
        state.quoteData = action.payload;
      })
      .addCase(getPolicy.pending, (state) => {
        state.policyLoader = true;
        state.status = false;
      })
      .addCase(getPolicy.fulfilled, (state, action) => {
        state.policyLoader = false;
        state.status = true;
        state.policyData =
          Array.isArray(action.payload) && !action.payload.length
            ? state.policyData
            : action.payload;
      })
      .addCase(getPolicy.rejected, (state, action) => {
        state.policyLoader = false;
        state.status = false;
        state.policyData = null;
      })
      .addCase(getCountryDetail.pending, (state) => {
        state.status = false;
      })
      .addCase(getCountryDetail.fulfilled, (state, action) => {
        state.status = true;
        state.countryDetails = action?.payload?.data;
      })
      .addCase(getCountryDetail.rejected, (state, action) => {
        state.status = false;
        state.countryDetails = action.payload;
      })
      .addCase(getTravelProductType.pending, (state) => {
        state.status = false;
      })
      .addCase(getTravelProductType.fulfilled, (state, action) => {
        state.status = true;
        state.travelProductType = action?.payload?.data;
      })
      .addCase(getTravelProductType.rejected, (state, action) => {
        state.status = false;
        state.travelProductType = action.payload;
      })
      .addCase(getAoMasterData.pending, (state) => {
        state.status = false;
        state.aoMasterDataLoader = true;
      })
      .addCase(getAoMasterData.fulfilled, (state, action) => {
        state.status = true;
        state.aoMasterDataLoader = false;
        state.aoMasterData = action?.payload?.data;
      })
      .addCase(getAoMasterData.rejected, (state, action) => {
        state.status = false;
        state.aoMasterDataLoader = false;
        state.aoMasterData = action.payload;
      })
      .addCase(getTakafulMasterData.pending, (state) => {
        state.status = false;
        state.takafulMasterDataLoader = true;
      })
      .addCase(getTakafulMasterData.fulfilled, (state, action) => {
        // console.log('action.payload', action.meta.arg);
        if (action.meta.arg === "title") {
          state.takafulTitleMasterData = action.payload?.data;
        } else if (action.meta.arg === "nationality") {
          state.takafulNationalityCompanyMasterData = action.payload?.data;
        } else if (action.meta.arg === "governate") {
          state.takafulGovernateCompanyMasterData = action.payload?.data;
        } else if (action.meta.arg.includes("wilayat")) {
          state.takafulWilayatCompanyMasterData = action.payload?.data;
        }
        state.status = true;
        state.takafulMasterDataLoader = false;
        state.takafulMasterData = action?.payload?.data;
      })
      .addCase(getTakafulMasterData.rejected, (state, action) => {
        state.status = false;
        state.takafulMasterDataLoader = false;
        state.takafulMasterData = action.payload;
      })
      .addCase(getLicenseVehicle.pending, (state) => {
        state.status = false;
      })
      .addCase(getLicenseVehicle.fulfilled, (state, action) => {
        state.vehicleData = action?.payload;
        state.status = true;
        state.fetchingVehicleDataLoader = false;
      })
      .addCase(getLicenseVehicle.rejected, (state, action) => {
        state.status = false;
        state.fetchingVehicleDataLoader = false;
      })
      .addCase(getPlateTypeDetails.pending, (state) => {
        state.fetchingVehicleDataLoader = true;
        state.status = false;
      })
      .addCase(getPlateTypeDetails.fulfilled, (state, action) => {
        state.status = true;
        state.plateTypeDetails = action?.payload?.data;
      })
      .addCase(getPlateTypeDetails.rejected, (state, action) => {
        state.status = false;
        state.fetchingVehicleDataLoader = false;
      })
      .addCase(getGigVehicaleValuation.pending, (state) => {
        state.status = false;
      })
      .addCase(getGigVehicaleValuation.fulfilled, (state, action) => {
        state.status = true;
        state.gigVehicaleValuationData = action?.payload?.data;
      })
      .addCase(getGigVehicaleValuation.rejected, (state, action) => {
        state.status = false;
        state.fetchingVehicleDataLoader = false;
      })
      .addCase(updateTakafulPremium.pending, (state) => {
        state.updateTakafulPremiumLoader = true;
        // state.status = false;
      })
      .addCase(updateTakafulPremium.fulfilled, (state, action) => {
        state.updateTakafulPremiumLoader = false;
        // state.status = true;
      })
      .addCase(updateTakafulPremium.rejected, (state, action) => {
        state.updateTakafulPremiumLoader = false;
        // state.status = false;
      })
      .addCase(getEbridgeQuotes.pending, (state) => {
        state.ebridgeLoader = true;
        state.ebridgeInsuranceData = null;
      })
      .addCase(getEbridgeQuotes.fulfilled, (state, action) => {
        state.ebridgeLoader = false;
        state.ebridgeInsuranceData = prepareEbridgeInsuranceCardData(
          action.payload.quotes,
          action.payload.productDetails
        );
      })
      .addCase(getEbridgeQuotes.rejected, (state) => {
        state.ebridgeLoader = false;
        state.ebridgeInsuranceData = [];
      });
  },
});

export const {
  updateTotalPrice,
  resetData,
  updateGigInsuranceData,
  updateAoInsuranceData,
  updateOquicInsuranceData,
  resetVehicleData,
  resetEbridgeData,
  updateEbridgeInsuranceData,
} = productSlice.actions;
export default productSlice.reducer;
